export default {
  GET_VIDEO_REQUESTED: 'GET_VIDEO_REQUESTED',
  GET_VIDEO_SUCCEEDED: 'GET_VIDEO_SUCCEEDED',
  GET_VIDEO_FAILED: 'GET_VIDEO_FAILED',
};
